import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const GutterCleaning = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my gutter cleaning business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps gutter cleaning businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for gutter cleaning businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most gutter cleaning businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my gutter cleaning business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like gutter cleaning. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Gutter Cleaning - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Gutter Cleaning CRM", url: "/industries/gutter-cleaning" }
  ];

  const industryData = {
    name: 'Gutter Cleaning',
    title: 'Capture Seasonal Rush & Build Recurring Service Revenue',
    subtitle: 'Automate seasonal reminders, optimize service routes, and convert one-time cleans to annual contracts',
    icon: '🍂',
    challenges: [
      'All calls come in fall at same time',
      'Customers forget about spring cleaning',
      'Weather causes constant rescheduling',
      'Hard to fill schedule in slow seasons',
      'One-time customers never return'
    ],
    solutions: [
      'Pre-season booking automation',
      'Bi-annual service reminders',
      'Weather-based rescheduling',
      'Off-season service promotions',
      'Annual contract tracking'
    ],
    features: [
      'Customer CRM with service history',
      'Seasonal reminder automation',
      'Route optimization',
      'Weather notifications',
      'Before/after documentation',
      'Gutter guard upsells',
      'Online booking',
      'Review requests'
    ],
    results: [
      '70% become annual clients',
      'Book 6 weeks in advance',
      'Consistent year-round revenue',
      '£4.4K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Gutter Cleaning UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for gutter cleaning businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for gutter cleaning UK, gutter cleaning business software, gutter cleaning customer management, gutter cleaning lead generation UK"
        url="/industries/gutter-cleaning"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default GutterCleaning;